/**
 * Проверяет сигнатуру (magic bytes) файла
 */
export async function validateFileSignature(file: File): Promise<boolean> {
    // Для .ts файлов проверяем MPEG-TS сигнатуру
    if (file.name.toLowerCase().endsWith('.ts')) {
        return validateMpegTsSignature(file);
    }

    return true;
}

/**
 * Проверяет, является ли файл действительно MPEG-TS
 * MPEG-TS пакеты начинаются с синхробайта 0x47
 */
async function validateMpegTsSignature(file: File): Promise<boolean> {
    try {
        // Читаем первые 188 байт (размер одного TS пакета)
        const slice = file.slice(0, 188);
        const arrayBuffer = await slice.arrayBuffer();
        const bytes = new Uint8Array(arrayBuffer);

        // Проверяем, что первый байт - это синхробайт 0x47
        if (bytes.length > 0 && bytes[0] === 0x47) {
            // Дополнительная проверка: каждый TS пакет имеет размер 188 или 204 байта
            // и начинается с 0x47. Проверим несколько пакетов если файл достаточно большой
            if (file.size >= 376) {
                const slice2 = file.slice(188, 376);
                const arrayBuffer2 = await slice2.arrayBuffer();
                const bytes2 = new Uint8Array(arrayBuffer2);

                if (bytes2.length > 0 && bytes2[0] === 0x47) {
                    return true;
                }
            } else {
                return true;
            }
        }

        return false;
    } catch (error) {
        console.error('Error validating MPEG-TS signature:', error);
        return false;
    }
}
